// extracted by mini-css-extract-plugin
export var backgroundImage = "topic-selector-link-dr-module--background-image--eabf0";
export var black = "topic-selector-link-dr-module--black--9786c";
export var calendar = "topic-selector-link-dr-module--calendar--3c6f0";
export var gears = "topic-selector-link-dr-module--gears--6ef6a";
export var gray = "topic-selector-link-dr-module--gray--9039e";
export var icon = "topic-selector-link-dr-module--icon--13dbe";
export var iconImage = "topic-selector-link-dr-module--icon-image--d8a6b";
export var info = "topic-selector-link-dr-module--info--e4b00";
export var support = "topic-selector-link-dr-module--support--2b5a4";
export var tools = "topic-selector-link-dr-module--tools--9969f";
export var topicSelectorLink = "topic-selector-link-dr-module--topic-selector-link--29249";
export var user = "topic-selector-link-dr-module--user--be183";
export var white = "topic-selector-link-dr-module--white--545a6";